module.exports = __webpack_public_path__ + "img/other4.d0e5fa2c.png";